module.exports = __webpack_public_path__ + "static/img/1.Webpay_FB_800.dc1edc2f.svg";